import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { api } from "@/lib/api";

const CONSENT_TEXT = "I authorize Los Viejevos P\u00e1del Society / LV Pass to receive, use and process relevant information about my membership, bookings, playing activity and use of member benefits from participating clubs, partners, booking and playing platforms, and other authorized third-party platforms. This information may be used to verify and administer my membership and privileges, recognize eligible activity, support community features, and improve my LV Pass experience. I understand that I may withdraw this consent at any time.";

export default function Consent() {
  const [accepted, setAccepted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const { refresh } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!accepted) { setError("Please read and accept the consent to continue."); return; }
    setError(null);
    setLoading(true);
    try {
      await api.post("/member/consent", { consent_type: "MEMBER_DATA_CONSENT", consent_version: "1.0", accepted: true });
      await refresh();
      navigate("/onboarding/complete", { replace: true });
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-lv-bg flex items-center justify-center px-6 py-12" data-testid="consent-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <span className="font-serif text-2xl text-cream tracking-[0.25em]">LV PASS</span>
          <p className="text-xs tracking-[0.3em] uppercase text-lv-muted mt-4">Member Data Consent</p>
        </div>

        <div className="bg-walnut border border-lv-border p-5 sm:p-6 mb-6">
          <p className="text-sm text-sand/90 leading-relaxed" data-testid="consent-text">
            {CONSENT_TEXT}
          </p>
        </div>

        {error && <div className="mb-4 p-3 border border-lv-inactive/30 bg-lv-inactive/10 text-sand text-sm" data-testid="consent-error">{error}</div>}

        <form onSubmit={handleSubmit} className="space-y-6">
          <label className="flex items-start gap-3 cursor-pointer min-h-[44px]" data-testid="consent-checkbox-label">
            <input
              type="checkbox"
              checked={accepted}
              onChange={(e) => setAccepted(e.target.checked)}
              className="w-5 h-5 mt-0.5 accent-bronze shrink-0"
              data-testid="consent-checkbox"
            />
            <span className="text-sm text-cream leading-relaxed">
              I have read and consent to the use of my information as described above.
            </span>
          </label>

          <button type="submit" disabled={loading || !accepted} className="lv-btn-primary w-full min-h-[48px]" data-testid="consent-submit">
            {loading ? "Saving\u2026" : "Continue"}
          </button>
        </form>

        <p className="text-center mt-6">
          <a href="#" className="text-xs text-lv-muted hover:text-bronze transition-colors tracking-wide">
            Learn how we use and protect your information
          </a>
        </p>
      </div>
    </div>
  );
}
